import { Action } from '@ngrx/store';

import { Toast } from '@stylehaven/components';

export enum ToastActionTypes {
    AddToast = '[Toast] Add',
    DeleteToast = '[Toast] Delete',
    UpdateToast = '[Toast] Update',
    UpsertToast = '[Toast] Upsert',
    Clear = '[Toast] Clear all'
}

export class AddToast implements Action {
    readonly type: ToastActionTypes.AddToast = ToastActionTypes.AddToast;
    constructor(public toast: Toast) {}
}

export class UpdateToast implements Action {
    readonly type: ToastActionTypes.UpdateToast = ToastActionTypes.UpdateToast;
    constructor(
        public id: number,
        public changes: Partial<Toast>
    ) {}
}

export class UpsertToast implements Action {
    readonly type: ToastActionTypes.UpsertToast = ToastActionTypes.UpsertToast;
    constructor(public toast: Toast) {}
}

export class DeleteToast implements Action {
    readonly type: ToastActionTypes.DeleteToast = ToastActionTypes.DeleteToast;
    constructor(public id: number) {}
}

export class ClearToasts implements Action {
    readonly type: ToastActionTypes.Clear = ToastActionTypes.Clear;
}

export type ToastAction = AddToast | DeleteToast | UpdateToast | UpsertToast | ClearToasts;
